<app-loading-spinner
  *ngIf="isLoading"
  class="spinner-full-page"
/>

<app-header></app-header>

<mat-card
  *ngIf="!isLoading"
  class="full-content"
>
  <mat-card-content class="content">
    <div style="margin-top: 0; margin-bottom: 20px; margin-left: 20px; margin-right: 20px">
      <app-carousel [screenType]="screenType"></app-carousel>
    </div>

    <!-- <mat-card
      id="login-feature-banner"
      class="section-card"
      style="background-color: orange; text-align: center"
    >
      <div>
        ALERT: Users can now login/register and see complete order history.

        <br />
        <a
          style="margin-left: 1rem"
          href="/login"
          >Login Page</a
        >

        <span style="margin-left: 1rem">( customers.zippmat.in )</span>
      </div>
    </mat-card> -->

    <mat-card
      id="enquiry-details"
      class="section-card"
    >
      <mat-card-title class="section-header-2-up customer-name">{{ customerName }}</mat-card-title>

      <mat-card-title class="section-header-2-down">Enquiry Details</mat-card-title>

      <mat-card-content class="no-padding">
        <div class="grid-display-2">
          <p>Enquiry Number:</p>
          <b>{{ enquiryBasicData.enquiryNum }}</b>

          <p>Enquiry Date:</p>
          <b>{{ enquiryBasicData.enquiryDate }}</b>

          <p>Relationship Manager:</p>
          <b>{{ relationshipManagerData.name }}</b>

          <p>Delivery Address:</p>
          <b>{{ enquiryBasicData.deliveryAddress }}</b>

          <p>Delivery PIN Code:</p>
          <b>{{ enquiryBasicData.deliveryPincode | pincodeNumberFormat }}</b>

          <app-report-issue-button
            [entityId]="customerOrderId"
            [entityType]="entityType"
            [isInternalUser]="isInternalUser"
            [contactNumberWhatsapp]="relationshipManagerData.mobile"
          />

          <app-share-requirements-button [publicId]="publicRequirementsId"> </app-share-requirements-button>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card
      id="requirement-items"
      class="section-card normal-text"
    >
      <mat-card-title class="section-header">Requirement Items</mat-card-title>

      <div class="grid-display-5">
        <ng-container *ngFor="let row of orderItems; let i = index">
          <p style="grid-column: span 4">
            {{ row.itemDescription }}
          </p>

          <b>
            {{ row.itemQty }}
          </b>

          <hr style="grid-column: span 5" />
        </ng-container>
      </div>
    </mat-card>

    <mat-card
      id="quotes"
      class="section-card"
    >
      <mat-card-title class="section-header">Quotes </mat-card-title>

      <div class="grid-display-2">
        <ng-container *ngFor="let row of quotationList; let i = index">
          <b>{{ row.quotationNum }}</b>

          <app-file-download-button
            style="margin-left: auto"
            [fileUrl]="row.quotationPdfUrl"
          >
          </app-file-download-button>

          <ul style="grid-column: span 2">
            <li>{{ row.quotationMessage }}</li>
          </ul>

          <hr style="grid-column: span 2" />
        </ng-container>
      </div>
    </mat-card>

    <mat-card
      id="invoices"
      class="section-card"
    >
      <mat-card-title class="section-header">Invoices</mat-card-title>

      <p style="font-weight: 600; color: green; margin-bottom: 2rem">
        NOTE: For documents related to invoices, such as the Material Test Certificate and GRN, please log in to the

        <a
          href="/login"
          target="_blank"
        >
          Customer Portal
        </a>
      </p>

      <div class="grid-display-3">
        <ng-container *ngFor="let row of invoiceList; let i = index">
          <p>{{ row.invoiceNum }}</p>

          <div class="chips">
            <mat-chip
              class="status-chip"
              [ngClass]="getInvoiceStatusChipClass(row.invoiceStatus)"
            >
              {{ row.invoiceStatus.value }}
            </mat-chip>
          </div>

          <app-file-download-button
            style="margin-left: auto"
            [fileUrl]="row.customerInvoiceUrl"
          >
          </app-file-download-button>

          <hr style="grid-column: span 3" />
        </ng-container>
      </div>
    </mat-card>

    <mat-card
      id="relationship-manager"
      class="section-card"
    >
      <mat-card-title class="section-header">Relationship Manager</mat-card-title>

      <div class="grid-display-3">
        <b style="grid-column: span 3">
          {{ relationshipManagerData.name }}
        </b>

        <p>Email:</p>
        <p style="grid-column: span 2">{{ relationshipManagerData.email }}</p>

        <p>Mobile:</p>
        <p style="grid-column: span 2">{{ relationshipManagerData.mobile | mobileNumberFormat }}</p>
      </div>
    </mat-card>
  </mat-card-content>
</mat-card>

<app-footer></app-footer>
